import commonActions from '../Common/action';
import { ActionKind } from '../Common/interface';
import { ACTION_TYPE } from './interface';

const actions = {
  setEmailCode: (emailCode: string) => {
    const action: ACTION_TYPE = {
      type: ActionKind.SetEmailCode,
      payload: emailCode,
    };
    return action;
  },

  signupSuccess: (result: object) => {
    const action: ACTION_TYPE = {
      type: ActionKind.SignupSuccess,
      payload: result,
    };
    return action;
  },

  signupFailure: errorInfo => {
    const action: ACTION_TYPE = {
      type: ActionKind.SignupFailure,
      payload: errorInfo,
    };
    return action;
  },

  resendEmailOTPSuccess: () => {
    const action: ACTION_TYPE = {
      type: ActionKind.ResendEmailOTPSuccess,
    };
    return action;
  },

  resendEmailOTPFailure: errorInfo => {
    const action: ACTION_TYPE = {
      type: ActionKind.ResendEmailOTPFailure,
      payload: errorInfo,
    };
    return action;
  },

  enableResend: () => {
    const action: ACTION_TYPE = {
      type: ActionKind.EnableResend,
    };
    return action;
  },

  recaptchaError: commonActions.recaptchaError,
  setLoader: commonActions.setLoader,
};

export default actions;
